import {SunDim, Windmill} from "@phosphor-icons/react";

var et = [
		{label:"All", value:"", icon:""},
		{label:"Wind", value:"Wind", icon:"ri-wind-turbine"},
		{label:"Solar", value:"Solar", icon:"ri-sun-line"},
	];


const energyTypes = {
	
	
	types: [
		{
			label:"Wind", 
			value:"Wind", 
			className:"tech-icon tech-wind",
			icon: <Windmill size={16} />
		},
		{
			label:"Solar", 
			value:"Solar", 
			className:"tech-icon tech-solar",
			icon: <SunDim size={16} />
		}
	],
	"get": function(value){
		
		const v = Array.isArray(value) ? value : [value];
		
		var res = [];
		
		v.forEach((val)=>{
			const r = this.types.find((a)=>{return a.value == val});
			if(r)
				res.push(r);
		});
		return res.length > 1 ? res : res[0];	
	},
};



export { et,energyTypes};